/**
 * @generated SignedSource<<2c71acff13476d0c3417ff5974c83ce0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppClipActionTitle = "OPEN" | "VIEW" | "%future added value";
export type AppColorPalette = "ACCENT_1" | "ACCENT_2" | "ACCENT_3" | "BACKGROUND_1" | "BACKGROUND_2" | "BLACK" | "GRAY" | "PRIMARY" | "WHITE" | "%future added value";
export type AppStoreCategory = "BOOKS" | "BUSINESS" | "DEVELOPER_TOOLS" | "EDUCATION" | "ENTERTAINMENT" | "FINANCE" | "FOOD_AND_DRINK" | "GAMES" | "GRAPHICS_AND_DESIGN" | "HEALTH_AND_FITNESS" | "LIFESTYLE" | "MAGAZINES_AND_NEWSPAPERS" | "MEDICAL" | "MUSIC" | "NAVIGATION" | "NEWS" | "PHOTO_AND_VIDEO" | "PRODUCTIVITY" | "REFERENCE" | "SHOPPING" | "SOCIAL_NETWORKING" | "SPORTS" | "STICKERS" | "TRAVEL" | "UTILITIES" | "WEATHER" | "%future added value";
export type AppTrackingConfig = "CONVERSION_BEAR" | "CUSTOM" | "ISENSE" | "ONE_TRUST" | "TERMLY" | "TRANSCEND" | "%future added value";
export type AutomatedNotificationType = "ABANDONED_BROWSE" | "ABANDONED_CART" | "ABANDONED_CHECKOUT" | "REENGAGEMENT" | "WELCOME_SERIES" | "%future added value";
export type ButtonTextStyleType = "SENTENCE_CASE" | "UPPERCASE" | "%future added value";
export type CDPAudienceType = "LIST" | "SEGMENT" | "%future added value";
export type CDPType = "EMARSYS" | "KINN" | "KLAVIYO" | "OMETRIA" | "SHOPIFY" | "%future added value";
export type IconType = "ACTIVITY" | "AIRPLAY" | "ALERT_CIRCLE" | "ALERT_OCTAGON" | "ALERT_TRIANGLE" | "ALIGN_CENTER" | "ALIGN_JUSTIFY" | "ALIGN_LEFT" | "ALIGN_RIGHT" | "ANCHOR" | "APERTURE" | "ARCHIVE" | "ARROW_DOWN" | "ARROW_DOWN_CIRCLE" | "ARROW_DOWN_LEFT" | "ARROW_DOWN_RIGHT" | "ARROW_LEFT" | "ARROW_LEFT_CIRCLE" | "ARROW_RIGHT" | "ARROW_RIGHT_CIRCLE" | "ARROW_UP" | "ARROW_UP_CIRCLE" | "ARROW_UP_LEFT" | "ARROW_UP_RIGHT" | "AT_SIGN" | "AWARD" | "BAR_CHART" | "BAR_CHART_2" | "BATTERY" | "BATTERY_CHARGING" | "BELL" | "BELL_FILL" | "BELL_OFF" | "BLUETOOTH" | "BOLD" | "BOOK" | "BOOKMARK" | "BOOK_OPEN" | "BOX" | "BRIEFCASE" | "CALENDAR" | "CAMERA" | "CAMERA_OFF" | "CAST" | "CHECK" | "CHECK_CIRCLE" | "CHECK_SQUARE" | "CHEVRONS_DOWN" | "CHEVRONS_LEFT" | "CHEVRONS_RIGHT" | "CHEVRONS_UP" | "CHEVRON_DOWN" | "CHEVRON_LEFT" | "CHEVRON_RIGHT" | "CHEVRON_UP" | "CHROME" | "CIRCLE" | "CLIPBOARD" | "CLOCK" | "CLOUD" | "CLOUD_DRIZZLE" | "CLOUD_LIGHTNING" | "CLOUD_OFF" | "CLOUD_RAIN" | "CLOUD_SNOW" | "CODE" | "CODEPEN" | "CODESANDBOX" | "COFFEE" | "COLUMNS" | "COMMAND" | "COMPASS" | "COPY" | "CORNER_DOWN_LEFT" | "CORNER_DOWN_RIGHT" | "CORNER_LEFT_DOWN" | "CORNER_LEFT_UP" | "CORNER_RIGHT_DOWN" | "CORNER_RIGHT_UP" | "CORNER_UP_LEFT" | "CORNER_UP_RIGHT" | "CPU" | "CREDIT_CARD" | "CROP" | "CROSSHAIR" | "CUSTOM_CART" | "CUSTOM_CONCIERGE" | "CUSTOM_EXPERIENCES" | "CUSTOM_FEED" | "CUSTOM_PROFILE" | "CUSTOM_SHOP" | "DATABASE" | "DELETE" | "DISC" | "DIVIDE" | "DIVIDE_CIRCLE" | "DIVIDE_SQUARE" | "DOLLAR_SIGN" | "DOWNLOAD" | "DOWNLOAD_CLOUD" | "DRIBBBLE" | "DROPLET" | "EDIT" | "EDIT_2" | "EDIT_3" | "EXTERNAL_LINK" | "EYE" | "EYE_OFF" | "FACEBOOK" | "FAST_FORWARD" | "FEATHER" | "FIGMA" | "FILE" | "FILE_MINUS" | "FILE_PLUS" | "FILE_TEXT" | "FILM" | "FILTER" | "FLAG" | "FOLDER" | "FOLDER_MINUS" | "FOLDER_PLUS" | "FOR_YOU" | "FRAMER" | "FROWN" | "GIFT" | "GITHUB" | "GITLAB" | "GIT_BRANCH" | "GIT_COMMIT" | "GIT_MERGE" | "GIT_PULL_REQUEST" | "GLOBE" | "GRID" | "HARD_DRIVE" | "HASH" | "HEADPHONES" | "HEART" | "HELP_CIRCLE" | "HEXAGON" | "HOME" | "IMAGE" | "INBOX" | "INFO" | "INSTAGRAM" | "ITALIC" | "KEY" | "LAYERS" | "LAYOUT" | "LIFE_BUOY" | "LINK" | "LINKEDIN" | "LINK_2" | "LIST" | "LOADER" | "LOCK" | "LOG_IN" | "LOG_OUT" | "MAIL" | "MAP" | "MAP_PIN" | "MAXIMIZE" | "MAXIMIZE_2" | "MEH" | "MENU" | "MESSAGE_CIRCLE" | "MESSAGE_SQUARE" | "MESSAGE_SQUARE_FILL" | "MIC" | "MIC_OFF" | "MINIMIZE" | "MINIMIZE_2" | "MINUS" | "MINUS_CIRCLE" | "MINUS_SQUARE" | "MONITOR" | "MOON" | "MORE_HORIZONTAL" | "MORE_VERTICAL" | "MOUSE_POINTER" | "MOVE" | "MUSIC" | "NAVIGATION" | "NAVIGATION_2" | "OCTAGON" | "PACKAGE" | "PAPERCLIP" | "PAUSE" | "PAUSE_CIRCLE" | "PEN_TOOL" | "PERCENT" | "PHONE" | "PHONE_CALL" | "PHONE_FORWARDED" | "PHONE_INCOMING" | "PHONE_MISSED" | "PHONE_OFF" | "PHONE_OUTGOING" | "PIE_CHART" | "PLAY" | "PLAY_CIRCLE" | "PLUS" | "PLUS_CIRCLE" | "PLUS_SQUARE" | "POCKET" | "POWER" | "PRINTER" | "RADIO" | "REFRESH_CCW" | "REFRESH_CW" | "REPEAT" | "REWIND" | "ROTATE_CCW" | "ROTATE_CW" | "RSS" | "SAVE" | "SCISSORS" | "SEARCH" | "SEND" | "SERVER" | "SETTINGS" | "SHARE" | "SHARE_2" | "SHIELD" | "SHIELD_OFF" | "SHOPPING_BAG" | "SHOPPING_CART" | "SHUFFLE" | "SIDEBAR" | "SKIP_BACK" | "SKIP_FORWARD" | "SLACK" | "SLASH" | "SLIDERS" | "SMARTPHONE" | "SMILE" | "SPEAKER" | "SQUARE" | "STAR" | "STOP_CIRCLE" | "SUN" | "SUNRISE" | "SUNSET" | "TABLE" | "TABLET" | "TAG" | "TARGET" | "TERMINAL" | "THERMOMETER" | "THUMBS_DOWN" | "THUMBS_UP" | "TOGGLE_LEFT" | "TOGGLE_RIGHT" | "TOOL" | "TRASH" | "TRASH_2" | "TRELLO" | "TRENDING_DOWN" | "TRENDING_UP" | "TRIANGLE" | "TRUCK" | "TV" | "TWITCH" | "TWITTER" | "TYPE" | "UMBRELLA" | "UNDERLINE" | "UNLOCK" | "UPLOAD" | "UPLOAD_CLOUD" | "USER" | "USERS" | "USER_CHECK" | "USER_MINUS" | "USER_PLUS" | "USER_X" | "VIDEO" | "VIDEO_OFF" | "VOICEMAIL" | "VOLUME" | "VOLUME_1" | "VOLUME_2" | "VOLUME_2_FILL" | "VOLUME_X" | "VOLUME_X_FILL" | "WATCH" | "WIFI" | "WIFI_OFF" | "WIND" | "X" | "X_CIRCLE" | "X_OCTAGON" | "X_SQUARE" | "YOUTUBE" | "ZAP" | "ZAP_OFF" | "ZOOM_IN" | "ZOOM_OUT" | "%future added value";
export type KinnLanguageCode = "AR" | "DE" | "EN" | "ES" | "FR" | "NL" | "PT" | "%future added value";
export type LaunchScreenOption = "CUSTOM" | "SIMPLE" | "%future added value";
export type TabType = "ACCOUNT" | "FORUM" | "FOR_YOU" | "NOTIFICATIONS" | "SHOP" | "WEB" | "%future added value";
export type BrandAppConfigInputPartial = {
  abandonedCartNotificationsDelaySeconds?: number | null;
  abandonedCartNotificationsEnabled?: boolean | null;
  accent1PaletteDark?: string | null;
  accent1PaletteLight?: string | null;
  accent2PaletteDark?: string | null;
  accent2PaletteLight?: string | null;
  accent3PaletteDark?: string | null;
  accent3PaletteLight?: string | null;
  androidAppLinksEnabled?: boolean | null;
  androidFirebaseAnalyticsEnabled?: boolean | null;
  appClipActionText?: AppClipActionTitle | null;
  appClipHeaderImage?: any | null;
  appClipSubtitle?: string | null;
  appContent?: BrandAppConfigContentInputPartial | null;
  appDescription?: string | null;
  appIcon?: any | null;
  appName?: string | null;
  appSubtitle?: string | null;
  automatedNotifications?: ReadonlyArray<GraphQLAutomatedNotificationInput> | null;
  background1PaletteDark?: string | null;
  background1PaletteLight?: string | null;
  background2PaletteDark?: string | null;
  background2PaletteLight?: string | null;
  buildNavigation?: BrandAppConfigBuildNavigationInputPartial | null;
  buildTheme?: BrandAppConfigBuildThemeInputPartial | null;
  cartIgnoredProductIds?: ReadonlyArray<string> | null;
  collectNameOnRegistration?: boolean | null;
  copyright?: string | null;
  enableLanguageSpecificContent?: boolean | null;
  htmlCustomAttributes?: ReadonlyArray<HTMLCustomAttributeInput> | null;
  id: string;
  iosAppClipsEnabled?: boolean | null;
  iosFirebaseAnalyticsEnabled?: boolean | null;
  iosFirebaseConfigPlist?: string | null;
  iosUniversalLinksEnabled?: boolean | null;
  keywords?: string | null;
  marketingUrl?: string | null;
  openCartAfterUpdate?: boolean | null;
  postPurchaseOptInEnabled?: boolean | null;
  primaryCategory?: AppStoreCategory | null;
  primaryPaletteDark?: string | null;
  primaryPaletteLight?: string | null;
  privacyPolicyUrl?: string | null;
  promotionalText?: string | null;
  releaseNotes?: string | null;
  screenshots?: GraphQLBrandAppConfigScreenshotInputPartialListInput | null;
  secondaryCategory?: AppStoreCategory | null;
  supportUrl?: string | null;
  supportedLanguageCodes?: ReadonlyArray<KinnLanguageCode> | null;
  trackingConfig?: BrandTrackingConfigInputPartial | null;
  usePasswordlessLogin?: boolean | null;
  wishlistUrl?: string | null;
};
export type HTMLCustomAttributeInput = {
  attributeKey: string;
  attributeValue: string;
  querySelector: string;
};
export type BrandAppConfigContentInputPartial = {
  abandonedCartNotificationBody?: string | null;
  abandonedCartNotificationTitle?: string | null;
  accountDeletionDialogSubtitle?: string | null;
  accountDeletionDialogTitle?: string | null;
  createAccountSubtitle?: string | null;
  createAccountTitle?: string | null;
  id: string;
  notificationsOptInSubtitle?: string | null;
  notificationsOptInTitle?: string | null;
  onboardingRootTitle?: string | null;
  onboardingUpsellSubtitle?: string | null;
  onboardingUpsellTitle?: string | null;
  signInSubtitle?: string | null;
  signInTitle?: string | null;
};
export type GraphQLAutomatedNotificationInput = {
  audiences?: ReadonlyArray<GraphQLCDPAudienceInput> | null;
  delaySeconds: number;
  id?: string | null;
  isEnabled?: boolean | null;
  landingPath?: string | null;
  message?: string | null;
  notifType: AutomatedNotificationType;
  resendEnabled?: boolean | null;
  title?: string | null;
};
export type GraphQLCDPAudienceInput = {
  audienceId: string;
  audienceName: string;
  audienceType: CDPAudienceType;
  cdpType: CDPType;
};
export type BrandTrackingConfigInputPartial = {
  configType: AppTrackingConfig;
  consentLocalStorageSettings?: ReadonlyArray<TrackingConfigSettingsInput> | null;
  consentSessionStorageSettings?: ReadonlyArray<TrackingConfigSettingsInput> | null;
  consentSettings: ReadonlyArray<TrackingConfigSettingsInput>;
  id?: string | null;
  nonConsentLocalStorageSettings?: ReadonlyArray<TrackingConfigSettingsInput> | null;
  nonConsentSessionStorageSettings?: ReadonlyArray<TrackingConfigSettingsInput> | null;
  nonConsentSettings: ReadonlyArray<TrackingConfigSettingsInput>;
  websiteId?: string | null;
};
export type TrackingConfigSettingsInput = {
  enabled: boolean;
  name: string;
};
export type GraphQLBrandAppConfigScreenshotInputPartialListInput = {
  add?: ReadonlyArray<GraphQLBrandAppConfigScreenshotInputPartial> | null;
  remove?: ReadonlyArray<GraphQLBrandAppConfigScreenshotInputPartial> | null;
  set?: ReadonlyArray<GraphQLBrandAppConfigScreenshotInputPartial> | null;
};
export type GraphQLBrandAppConfigScreenshotInputPartial = {
  id?: string | null;
  image?: any | null;
};
export type BrandAppConfigBuildNavigationInputPartial = {
  defaultTabType?: TabType | null;
  id: string;
  isForYouTabEnabled?: boolean | null;
  isGorgiasEnabled?: boolean | null;
};
export type BrandAppConfigBuildThemeInputPartial = {
  badgeBackground?: AppColorPalette | null;
  badgeForeground?: AppColorPalette | null;
  buttonBorderThickness?: number | null;
  buttonCartIcon?: IconType | null;
  buttonCornerRadius?: number | null;
  buttonTextStyle?: ButtonTextStyleType | null;
  fontBodyBold?: any | null;
  fontBodyRegular?: any | null;
  fontFaces?: ReadonlyArray<InternFontFamilyInfoInput> | null;
  fontHeadingBold?: any | null;
  fontHeadingRegular?: any | null;
  id: string;
  iosLiquidGlassEnabled?: boolean | null;
  launchScreenAsset?: any | null;
  launchScreenBackground?: AppColorPalette | null;
  launchScreenLogo?: any | null;
  launchScreenOption?: LaunchScreenOption | null;
  logo?: any | null;
  logoUrl?: string | null;
  navigationBackground?: AppColorPalette | null;
  navigationForeground?: AppColorPalette | null;
  notificationOptInAsset?: any | null;
  onboardingAsset?: any | null;
  onboardingBackground?: AppColorPalette | null;
  onboardingForeground?: AppColorPalette | null;
  pillContainerBackground?: AppColorPalette | null;
  primaryButtonBackground?: AppColorPalette | null;
  primaryButtonForeground?: AppColorPalette | null;
  primaryPillBackground?: AppColorPalette | null;
  primaryPillForeground?: AppColorPalette | null;
  secondaryButtonOutline?: AppColorPalette | null;
  secondaryPillOutline?: AppColorPalette | null;
  shouldUseHeaderFontForBody?: boolean | null;
};
export type InternFontFamilyInfoInput = {
  bold: InternFontWeightInfoInput;
  name: string;
  regular: InternFontWeightInfoInput;
};
export type InternFontWeightInfoInput = {
  fontFace: string;
  fontWeight: number;
  url: string;
};
export type HtmlConfigCardMutation$variables = {
  input: BrandAppConfigInputPartial;
};
export type HtmlConfigCardMutation$data = {
  readonly updateBrandAppConfig: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"HtmlConfigCard_brand">;
  };
};
export type HtmlConfigCardMutation = {
  response: HtmlConfigCardMutation$data;
  variables: HtmlConfigCardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HtmlConfigCardMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "updateBrandAppConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HtmlConfigCard_brand"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HtmlConfigCardMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "updateBrandAppConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "HTMLCustomAttribute",
                "kind": "LinkedField",
                "name": "htmlCustomAttributes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "querySelector",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "attributeKey",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "attributeValue",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3c4729662153c24b5daca90552294e3d",
    "id": null,
    "metadata": {},
    "name": "HtmlConfigCardMutation",
    "operationKind": "mutation",
    "text": "mutation HtmlConfigCardMutation(\n  $input: BrandAppConfigInputPartial!\n) {\n  updateBrandAppConfig(input: $input) {\n    id\n    ...HtmlConfigCard_brand\n  }\n}\n\nfragment HtmlConfigCard_brand on BrandType {\n  id\n  appConfig {\n    id\n    htmlCustomAttributes {\n      querySelector\n      attributeKey\n      attributeValue\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c54e851118d8801803a4b79b193a97fb";

export default node;
